import { render, staticRenderFns } from "./HistorialVentasEvento.vue?vue&type=template&id=28aaf247"
import script from "./HistorialVentasEvento.vue?vue&type=script&lang=js"
export * from "./HistorialVentasEvento.vue?vue&type=script&lang=js"
import style0 from "./HistorialVentasEvento.vue?vue&type=style&index=0&id=28aaf247&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports